import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {VehicleListItem} from "@handover/view-models/vehicle-list-item";

@Component({
  selector: 'handovermod-vehicle-item',
  templateUrl: './vehicle-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleItemComponent {
  @Input() model?: VehicleListItem = {} as VehicleListItem;
  @Input() isSelected = false;

  get elementId(): string {
    return `vehicle-${this.model?.vehicleId}`;
  }
}
